<script setup>
import { computed } from 'vue';

const props = defineProps({
  buttonCopy: { type: String, default: '' },
  isFocused: { type: Boolean, default: false },
  isWithProgress: { type: Boolean, default: false },
  progressSecondsRemaining: { type: Number, default: 0 },
  progressTotalSeconds: { type: Number, default: 0 },
});

// // TvP08Button setup functions

// // Matches the TVP8 "Progress Button" pattern — a fill-bar under the label that drains from
// // full width to 0 as time runs out, not a visible countdown number.
const progressFillPercent = computed(() => {
  if (!props.progressTotalSeconds) return 0;
  const ratio = props.progressSecondsRemaining / props.progressTotalSeconds;
  return Math.max(0, Math.min(1, ratio)) * 100;
});

// // TvP08Button handler functions

// // TvP08Button watchers
</script>

<template>
  <button class="tvp-08-button" :class="{ 'tvp-08-button--focused': isFocused }">
    <span
      v-if="isWithProgress"
      class="tvp-08-button__progress-fill"
      :style="{ width: `${progressFillPercent}%` }"
    ></span>
    <span class="tvp-08-button__copy">{{ buttonCopy }}</span>
  </button>
</template>

<style scoped lang="scss">
@use './tvp08button.scss';
</style>
